export default class ToFhir {
  public static patientName(
    firstname: string,
    middleName: string = "",
    lastname: string,
    initial: string = ""
  ) {
    let givenName = [firstname?.toLowerCase()?.trim()];
    if (middleName && middleName != "") {
      givenName.push(middleName?.toLowerCase()?.trim());
    }
    return {
      //prefix: initial,
      family: lastname?.toLowerCase()?.trim(),
      given: givenName,
    };
  }
  public static address(addressObj: any) {
    // console.log("addressObj", addressObj);
    const lineStreet = [addressObj.street1];
    !!addressObj.street2 && lineStreet.push(addressObj.street2);
    return [
      {
        line: lineStreet,
        city: addressObj.city,
        state: addressObj.state,
        district: addressObj.district,
        postalCode: addressObj.pincode.toString(),
      },
    ];
  }
  public static generalPractitioner(practitionerRoleIds: string[]) {
    if (!practitionerRoleIds || practitionerRoleIds.length === 0) {
      return null;
    }

    // Create an array of PractitionerRole references
    return practitionerRoleIds.map((practitionerRoleId: string) => {
      return {
        reference: `PractitionerRole/${practitionerRoleId}`,
      };
    });
  }
  public static telecom(mobile: number) {
    return [
      {
        system: "phone",
        value: mobile.toString(),
      },
      /*{
        system: "email",
        value: "ganesh@gmail.com",
      },*/
    ];
  }
  public static contact(contactObj: any) {
    // console.log("contactObj======", contactObj);
    return [
      {
        relationship: [{ text: contactObj.relationship }],
        name: {
          given: [contactObj.name],
        },
        telecom: [
          {
            system: "phone",
            value: contactObj.contactNumber.toString(),
          },
        ],
      },
    ];
  }
  public static identifier(idtype: string, idnumber: string) {
    return [
      {
        assigner: {
          display: idtype,
        },
        value: idnumber.toString(),
      },
    ];
  }
}
